import React, { useState, useEffect } from "react";
import axios from "axios";
import { DateBox, Popup, SelectBox } from "devextreme-react";
import { LoadPanel } from "devextreme-react/load-panel";
import { useNavigate } from "react-router-dom";
import { handleGetLocal } from "../../../../../services/auth-service";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { Toster } from "../../../../../components/Toster/Toster";
import { logOut } from "../../../../../components/Logout";
import { CreditAvailableColumns, quickDateOptions, getRange } from "./Data";
import { DynamicTabb } from "../../../../../components/DynamicTab/DynamicTab";
import moment from "moment";
import NewReallocatePaymentPopup from "./overviewPopUp/NewReallocatePaymnetPopup";
import { RecivePaymentModel } from "../../../HeaderPopupComponent/RecivePaymentModel";
import { getDateBoxFormat } from "../../../../Dateapi/dateFormatter";

export default function CreditAvailable( { setCallApi,
  callApi,
  reloadUserInfo}) {
  const navigate = useNavigate();
  const pathname = handleGetLocal("pathURL");

  const today = moment().format("YYYY-MM-DD");

  const [date, setDate] = useState({
    startDate: today,
    endDate: today,
  });

  const [quickDate, setQuickDate] = useState("Today");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
   const [rowInfoData, setRowInfoData] = useState([]);
  const [exportPopupOpen, setexportPopupOpen] = useState(false);
   const [reallocatePaymentPopup, setReallocatePaymentPopup] = useState(false);
   const [toastConfig, setToastConfig] = useState({
       isVisible: false,
       type: "",
       message: "",
     });
  const [userinfo, setUserInfo] = useState(null);
   const [gPersonOffenderId, setGPersonOffenderId] = useState('');
   const [errorhandling, seterrorhandling] = useState(false);
   const [gPersonId, setGPersonId] = useState("");
   const [recivePaymentModel, setRecivePaymentModel] = useState(false);
   const [paymentModal, setPaymentModal] = useState(false);


   useEffect(() => {
    if (gPersonOffenderId) {
      callUserInfo();
    }
  }, [gPersonOffenderId]);

  const callUserInfo = async () => {
    setLoad(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Account/getPersonDetail?${`offenderId=${gPersonOffenderId}`}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        }
      )
      .then((val) => {
        setLoad(false);
        setUserInfo(val?.data?.data);
      })
      .catch((val) => {
        setLoad(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        } else {
          seterrorhandling(true);
        }
      });
  };

  const getCreditAvailableList = async () => {
    setLoad(true);

    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Financial/credit-available-by-date?dStart=${date.startDate}&dEnd=${date.endDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: pathname,
          },
        }
      )
      .then((val) => {
        setLoad(false);

        if (val?.data?.data) {
          const formatted = val.data.data.map((x, i) => ({
            // actions: "", 
            // "Date": moment(x.dLastReceiptDate).format("MM/DD/YYYY"),
            Amount: x.fAmount,
            "Offender #": x.sOffenderNumber,
            "Offender Name": x.sPersonNameLastFirst,
            Age: x.iAge,
            Settled: x.bSettled,
            "Last DTOE": moment(x.dLastDTOE).format("MM/DD/YYYY"),
            "Last DOE": moment(x.dLastDOE).format("MM/DD/YYYY"),
            "Active Location": x.sLastActiveLocation,
            gPersonId: x.gPersonId,
            ID: i,
          }));

          setData(formatted);
        }
      })
      .catch((err) => {
        setLoad(false);
        if (!err?.response) navigate("/error/500");
        else if (err.response.status === 401) logOut();
      });
  };

  const handleQuickDate = (value) => {
    setQuickDate(value);

    const { start, end } = getRange(value);

    setDate({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
  };

  useEffect(() => {
    getCreditAvailableList();
  }, []);
  // Auto refresh when date changes
  useEffect(() => {
    if (date.startDate && date.endDate) {
      getCreditAvailableList();
    }
  }, [date.startDate, date.endDate]);

  return (
    <>
      <LoadPanel shadingColor="true" visible={load} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
     <Popup
        visible={reallocatePaymentPopup}
        onHiding={() => {
          setReallocatePaymentPopup(false);
        }}
        showTitle={false}
        width={982}
        height={722}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <NewReallocatePaymentPopup
          reallocatePaymentPopup={reallocatePaymentPopup}
          setReallocatePaymentPopup={setReallocatePaymentPopup}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          fieldID={rowInfoData?.gPaymentId}
          setCallApi={setCallApi}
          callApi={callApi}
          refreshApi={reloadUserInfo}
          typePopup={"Overview"}
          rowInfoData={rowInfoData}
        />
      </Popup>
       <Popup
              visible={recivePaymentModel}
              onHiding={() => {
                setRecivePaymentModel(false);
              }}
              showTitle={false}
              width={1500}
              height={900}
              showCloseButton={true}
              hideOnOutsideClick={false}
            >
              <RecivePaymentModel
                userinfo={userinfo}
                setRowInfoData={setRowInfoData}
                toastConfig={toastConfig}
                setToastConfig={setToastConfig}
                recivePaymentModel={recivePaymentModel}
                setRecivePaymentModel={setRecivePaymentModel}
                gPersonId={gPersonId}
                setPaymentModal={setPaymentModal}
                name={userinfo?.sFirstLast}
                refreshOnlinePayments={getCreditAvailableList}
              />
            </Popup>
     

      <div className="financial-page">
        <DynamicTabb />

        <div className="financial-page-section">
          <div className="credit-available-page-info">
            <p className="page-info-number">CR.3</p>
          </div>

          <div className="page-details-search-content" style={{ display: "flex", gap: 20 }}>
            <div className="display-flex-div">
              <label className="edit_container_label">Date</label>
              <DateBox displayFormat={getDateBoxFormat()}
                useMaskBehavior={true}
                value={date.startDate}
                onValueChange={(e) => setDate({ ...date, startDate: moment(e).format("YYYY-MM-DD") })}
              />
            </div>

            <div className="display-flex-div">
              <label className="edit_container_label">To</label>
              <DateBox displayFormat={getDateBoxFormat()}
                useMaskBehavior={true}
                value={date.endDate}
                onValueChange={(e) => setDate({ ...date, endDate: moment(e).format("YYYY-MM-DD") })}
              />
            </div>

            <div className="display-flex-div">
              <label className="edit_container_label">Quick Date</label>
              <SelectBox
                dataSource={quickDateOptions}
                valueExpr="name"
                displayExpr="name"
                value={quickDate}
                onValueChange={handleQuickDate}
                width={150}
              />
            </div>

            <button className="btn" onClick={getCreditAvailableList}>
              Refresh
              <svg
                className="svg-blue-white"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clipPath="url(#clip0_6247_15093)">
                  <path
                    d="M17.6493 6.34902C16.0193 4.71902 13.7093 3.77902 11.1693 4.03902C7.49929 4.40902 4.47929 7.38902 4.06929 11.059C3.51929 15.909 7.26929 19.999 11.9993 19.999C15.1893 19.999 17.9293 18.129 19.2093 15.439C19.5293 14.769 19.0493 13.999 18.3093 13.999C17.9393 13.999 17.5893 14.199 17.4293 14.529C16.2993 16.959 13.5893 18.499 10.6293 17.839C8.40929 17.349 6.61929 15.539 6.14929 13.319C5.30929 9.43902 8.25929 5.99902 11.9993 5.99902C13.6593 5.99902 15.1393 6.68902 16.2193 7.77902L14.7093 9.28902C14.0793 9.91902 14.5193 10.999 15.4093 10.999H18.9993C19.5493 10.999 19.9993 10.549 19.9993 9.99902V6.40902C19.9993 5.51902 18.9193 5.06902 18.2893 5.69902L17.6493 6.34902Z"
                    fill="#424167"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6247_15093">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button
              className="btn"
              onClick={() => {
                setexportPopupOpen(true);
              }}
            >
              Export
              <svg
                className="svg-blue-white"
                width="14"
                height="17"
                viewBox="0 0 14 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.59 6H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V6H2.41C1.52 6 1.07 7.08 1.7 7.71L6.29 12.3C6.68 12.69 7.31 12.69 7.7 12.3L12.29 7.71C12.92 7.08 12.48 6 11.59 6ZM0 16C0 16.55 0.45 17 1 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H1C0.45 15 0 15.45 0 16Z"
                  fill="#424167"
                />
              </svg>
            </button>
          </div>

          <div className="financial_tab_table">
            <Table1
              editTable={false}
              height={"auto"}
              Tablecoloum={CreditAvailableColumns}
              tableRow={data}
              load={load}
              // contextMenus={true}
               creditAvailable={true}
              mandatoryColoum={"Offender #"}
              setRowInfoData={setRowInfoData}
              coloumWidthText={"CreditAvailable"}
              exportPopupOpen={exportPopupOpen}
              setexportPopupOpen={setexportPopupOpen}
              exportwidth={27}
              exporttitle={"Credit-Available"}
              exportInDifferentFormate={true}
              setReallocatePaymentPopup={setReallocatePaymentPopup}
              setGPersonOffenderId={setGPersonOffenderId}
              setGPersonId={setGPersonId}
              setRecivePaymentModel={setRecivePaymentModel}
            />
          </div>
        </div>
      </div>
    </>
  );
}
